function getBrandPromotions(brands) {
  if (!brands || brands.length === 0) {
    return [];
  }
  const parsedBrands = brands.map(parseBrandFromCollection).filter((brand) => Boolean(brand));
  return parsedBrands;
}
function parseBrandFromCollection(brand) {
  const { promotionLink, promotionLogo, title, clickablePromotionLogo } = brand ?? {};
  if (!title) {
    return null;
  }
  return {
    name: title,
    url: promotionLink?.url,
    logo: promotionLogo?.url,
    clickableLogo: clickablePromotionLogo?.url
  };
}
export {
  getBrandPromotions
};
//# sourceMappingURL=get-brand-promotions.js.map
